import { createFileRoute, Outlet } from '@tanstack/react-router';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/processes/all-processes/$processId')({
  loader: createEntityBreadcrumbLoader('process', 'processId'),
  component: () => <Outlet />
});
